<template>
  <div>
    <div style="overflow: hidden">
      <slot name="title"> </slot>
      <span class="btn-group">
        <el-select
          @change="tidal"
          clearable
          size="mini"
          v-model="selectYear"
          v-if="timeType === '年'"
          style="width: 90px;float: left;margin-left: 10px;"
          placeholder="请选择">
        <el-option
          v-for="item in selectYears"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
        <el-button class="datatype" size="mini" @click="explorer" v-if="!dark">导出</el-button>
        <el-radio-group
          v-if="!dark"
          v-model="dataType"
          @change="onDataType"
          size="mini"
          class="datatype"
          fill="#3e7878">
          <el-radio-button label="1">投放量</el-radio-button>
          <el-radio-button label="2">入栏量</el-radio-button>
          <el-radio-button label="3">活跃量</el-radio-button>
          <el-radio-button label="4">调度率</el-radio-button>
          <el-radio-button label="5">周转率</el-radio-button>
        </el-radio-group>
        <el-radio-group
          @change="onTimeType"
          size="mini"
          v-model="timeType"
          style="margin-left: 8px "
          fill="#3e7878">
          <el-radio-button label="日"></el-radio-button>
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="年"></el-radio-button>
        </el-radio-group>
      </span>
    </div>
    <div id="totalChart" :style="{ height: height + 'px' }"></div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="monthchart"
      :title="dialogTitleMonth"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth">
      <template v-slot:content>
        <div id="monthchart"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="daychart"
      :title="dialogTitleDay"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay">
      <template v-slot:content>
        <div id="daychart"/>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { Line } from '@antv/g2plot'
import WDialog from '@/components/Model/index.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    WDialog
  },
  data() {
    return {
      chartData: [],
      height: 300,
      monthCache: null,
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      timeType: this.getDefaultTimeType(), // 0-日，1-月，2-年
      dataType: '5',
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {},
      // 电单车企业投放量
      brandThrowInData: [],
      // 类型配置中心
      typeConfig: {
        1: {
          label: '投放量',
          labelShort: '投放',
          valueKey: 'online',
          isRate: false,
          unit: '辆',
          // 自行车字段
          bikeField: 'online_num',
          // 电动车字段
          ebikeField: 'online_num_e'
        },
        2: {
          label: '入栏量',
          labelShort: '入栏',
          valueKey: 'site',
          isRate: false,
          unit: '辆',
          bikeField: 'site_num',
          ebikeField: 'site_num_e'
        },
        3: {
          label: '活跃量',
          labelShort: '活跃',
          valueKey: 'active',
          isRate: false,
          unit: '辆',
          bikeField: 'active_bike_num',
          ebikeField: 'active_bike_num_e'
        },
        4: {
          label: '调度率',
          labelShort: '调度',
          valueKey: 'dispatch',
          isRate: true,
          unit: '%',
          bikeField: 'dispatch_percent',
          ebikeField: 'dispatch_percent_e'
        },
        5: {
          label: '周转率',
          labelShort: '周转',
          valueKey: 'rent',
          isRate: true,
          unit: '%',
          bikeField: 'rent_percent',
          ebikeField: 'rent_percent_e'
        }
      }
    }
  },
  props: {
    realHeight: {
      type: Number,
      default: 300
    },
    selfAreaId: {
      type: String,
      defalut: ''
    },
    isAggregation: {
      type: [Boolean, String],
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    initTimeType: {
      type: String,
      default: '月'
    },
    // 针对日常值守总量曲线图
    initDataType: {
      type: String,
      default: null
    }
  },
  watch: {
    realHeight(val) {
      if (val) {
        this.getAreaBrandDetails()
        setTimeout(() => {
          this.tidal()
        }, 1000)
      }
    }
  },
  computed: {
    ...mapGetters([
      'userBikeType'
    ]),
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    },
    // 当前选中的类型配置
    currentTypeConfig() {
      return this.typeConfig[this.dataType] || this.typeConfig[1]
    }
  },
  created() {
    this.getAreaBrandDetails()
    setTimeout(() => {
      this.yearChange()
      // 判断当前时间是否为每月1号，每月1号展示品牌车辆状态统计日的数据
      const today = new Date()
      const isFirstDay = today.getDate() === 1
      this.timeType = isFirstDay ? '日' : this.initTimeType
      this.tidal()
    }, 1000)
    this.initBrandThrowInData()
  },
  methods: {
    getDefaultTimeType() {
      // 初始化当前时间是否为每月1号，每月1号展示品牌车辆状态统计日的数据
      const today = new Date()
      return today.getDate() === 1 ? '日' : '月'
    },
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear() // 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    getAreaBrandDetails() {
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              this.$message.warning(res.message)
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    onTimeType() {
      if (this.timeType === '年') {
        this.selectYear = this.selectYear ?? this.selectYears[0].value
      }
      this.tidal()
    },
    onSelectYear() {
      this.tidal()
    },
    explorer() {
      this.$emit('explorer', this.timeType)
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    tidal(data, id, chartName = 'chart') {
      const vm = this
      vm.dataType = vm.initDataType ? vm.initDataType : vm.dataType
      // 避免选中年份后再次选中月份，得到月份为new Date('年份')，params.month 最终为年份和默认1月数据
      const year = this.timeType === '年' ? vm.selectYear : undefined
      const format = year
        ? vm.getSiteParams(year)
        : vm.getSiteParams()
      const params = {
        selfAreaId: this.selfAreaId,
        year: format[0],
        dataType: vm.dataType
      }
      if (this.timeType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.timeType === '月') {
        params.month = format[1]
      }
      // 浮层数据获取参数
      if (data && data.time) {
        if (this.timeType === '月') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.time) < 10 ? '0' + data.time : data.time
        } else if (this.timeType === '年') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = Number(data.time) < 10 ? '0' + data.time : data.time
        }
      }
      Api.brandBikeOnline(params)
        .then((res) => {
          if (res.code === 200) {
            vm.$nextTick(() => {
              let type = '年'
              const today = new Date()
              let slicelength = 0
              if (params.year) {
                type = '年'
                if (!params.month && params.year == today.getFullYear()) {
                  slicelength = today.getMonth() + 1
                }
              }
              if (params.month) {
                type = '月'
                if (!params.day && params.month == today.getMonth() + 1) {
                  slicelength = today.getDate()
                }
              }
              if (params.day) {
                type = '日'
                if (params.day == today.getDate()) {
                  slicelength = today.getHours() + 1
                }
              }
              if (slicelength) {
                const newData = {}
                // 剔除查询当前时间为0的数据
                for (const key in res.data) {
                  // 活跃车辆
                  if (this.dataType !== '3') {
                    // 使用 reduce 方法求和
                    const sum = res.data[key].reduce((acc, obj) => {
                      return acc + obj.online_num + obj.online_num_e
                    }, 0)
                    if (sum > 0) {
                      newData[key] = res.data[key]
                    }
                  }
                }
                res.data = this.dataType === '3' ? res.data : newData
                for (const key in res.data) {
                  res.data[key] = res.data[key].slice(0, slicelength)
                }
              }
              this.chartData = res.data
              setTimeout(() => {
                this.initScale(
                  this.translateLineData(this.chartData, type),
                  id,
                  chartName
                )
              }, 1000)
            })
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const colorMap = {}
      // 过滤重复数据
      const newRealNames = [...new Set(this.realNames)]
      this.realNames = newRealNames
      for (let i = 0, len = newRealNames.length; i < len; i++) {
        const item = newRealNames[i]
        // 提取纯品牌名（去掉括号中的类型后缀）
        const pureBrand = item.includes('(') ? item.slice(0, item.lastIndexOf('(')) : item
        let color
        if (item.indexOf('单车') !== -1 || pureBrand.indexOf('单车') !== -1) {
          color = this.originColor(pureBrand) ? this.originColor(pureBrand) : this.color16()
        } else {
          color = this.eBrandOriginColor(pureBrand) ? this.eBrandOriginColor(pureBrand) : this.color16()
        }
        colorMap[item] = color
      }
      return colorMap
    },
    translateLineData(data, datatype) {
      const arr = []
      this.realNames = []
      const config = this.currentTypeConfig // 使用配置

      Object.entries(data).forEach(([key, values]) => {
        for (const val of values) {
          let time = '', date = ''
          if (datatype === '年') {
            time = Number(val.date.split('-')[1]) + '月'
            date = Number(val.date.split('-')[1])
          } else if (datatype === '月') {
            const day = Number(val.date.split('-')[2])
            time = String(day) + '日'
            date = day
          } else if (datatype === '日') {
            time = val.hour + '点'
            date = val.hour
          }

          // 使用配置动态获取值
          const names = this.getAction(key, config.labelShort)
          for (const name of names) {
            const isBike = name.includes('单车')
            // 根据车型获取对应字段的值
            const num = isBike ? val[config.bikeField] : val[config.ebikeField]

            arr.push({
              pinpai: name,
              date: time,
              num: num,
              time: date
            })
            this.realNames.push(name)
          }
        }
      })
      return arr
    },
    getAction(key, metricLabel) {
      const names = []
      const bpre = key.slice(0, 2)
      const epro = key
      const target = this.brandThrowInData[key]
      const hasBike = target && target.PutBikeNum + target.BrandBikeNum > 0
      const hasEBike = target && target.PutEBikeNum + target.BrandEBikeNum > 0

      if (this.isBicycle && hasBike) {
        names.push(`${bpre}单车(${metricLabel})`)
      }
      if (this.isElectricBike && hasEBike) {
        const name = epro === '美团出行' ? '美团电单' : epro
        names.push(`${name}(${metricLabel})`)
      }
      return names
    },
    onDataType() {
      this.tidal(null, 'totalChart', 'chart')
    },
    initScale(data, id, chartName) {
      data.sort((a, b) => {
        return a.time - b.time
      })
      // 有id表示自定义
      if (data.length === 0) {
        return
      }
      if (this[chartName]) {
        this[chartName].destroy()
      }
      const h = 130
      this.height = this.realHeight - h
      var sum = 0
      const chartId = id || 'totalChart'
      this[chartName] = new Line(chartId, {
        data: data,
        height: this.height,
        xField: 'date',
        yField: 'num',
        seriesField: 'pinpai',
        tooltip: {
          showTitle: true,
          customContent: (title, items) => {
            sum = items.reduce((total, item) => {
              return total + item.data.num
            }, 0)
            // 数组对象去重
            const newArr = () => {
              const map = new Map()
              for (const item of items) {
                if (!map.has(item.name)) {
                  map.set(item.name, item)
                }
              }
              return [...map.values()]
            }
            const newItems = newArr()
            let itemHtml = ''
            for (const val of newItems) {
              const num = Number(val.value).toFixed(2)
              itemHtml += `<li class="g2-tooltip-list-item" >
                  <span  class="g2-tooltip-marker" style="background:${val.color}"></span>
                  <span class="g2-tooltip-name">${val.name}</span>:
                  <span class="g2-tooltip-value">${this.dataType.includes('4') || this.dataType.includes('5') ? num : val.value}</span>
                </li>`
            }
            const html =
              `<div class="g2-tooltip-title">${title} ${this.filterDataType(this.dataType, sum)}</div>
             <ul class="g2-tooltip-list">` + itemHtml + '</ul>'
            return html
          }
        },
        legend: false, // 关闭自带图例
        point: {
          shape: () => {
            return 'circle'
          },
          size: 3,
          color: (datum) => {
            const colorMap = this.getColorsByNames()
            return colorMap[datum.pinpai] || this.color16() // 添加默认颜色兜底
          }
        },
        // 添加平滑曲线
        smooth: true,
        // 动画配置 - wave-in 波浪入场效果
        animation: {
          appear: {
            animation: 'wave-in',
            duration: 5000
          }
        },
        lineStyle: ({ pinpai }) => {
          const config = this.currentTypeConfig
          const labelShort = config.labelShort

          // 使用配置中的 labelShort 判断
          if (pinpai.indexOf(labelShort) > -1) {
            return {
              lineWidth: 3,
              lineDash: [3, 1]
            }
          } else if (pinpai.indexOf('站点') > -1) {
            return {
              lineWidth: 3
            }
          } else {
            return {
              lineWidth: 1
            }
          }
        },
        color: (datum) => {
          const colorMap = this.getColorsByNames()
          return colorMap[datum.pinpai] || this.color16() // 添加默认颜色兜底
        }
      })
      this[chartName].on('element:click', (event) => {
        // 点击数据
        if (event && event.data && event.data.data && event.data.data.num) {
          this.onClickPoint(event.data.data, sum)
        }
      })
      this[chartName].render()
      // 创建自定义图例
      this.$nextTick(() => {
        this.createCustomLegend(chartId, chartName, data)
      })
    },
    createCustomLegend(chartId, chartName, allData) {
      const chartContainer = document.getElementById(chartId)
      if (!chartContainer) return

      // 移除旧图例容器
      const legendId = `custom-legend-${chartId}`
      const oldLegend = document.getElementById(legendId)
      if (oldLegend) {
        oldLegend.remove()
      }

      // 获取所有品牌
      const brands = [...new Set(allData.map(item => item.pinpai))]

      // 创建图例容器
      const legendContainer = document.createElement('div')
      legendContainer.id = legendId
      legendContainer.style.display = 'flex'
      legendContainer.style.flexWrap = 'wrap'
      legendContainer.style.alignItems = 'center'
      legendContainer.style.padding = '8px 0'
      legendContainer.style.gap = '5px'
      legendContainer.style.justifyContent = 'flex-start'
      legendContainer.style.lineHeight = '1'

      // 插入到图表容器前面
      const parent = chartContainer.parentNode
      parent.insertBefore(legendContainer, chartContainer)

      const colorMap = this.getColorsByNames()

      // 当前选中的品牌（为空表示全部显示）
      let selectedItems = []

      const renderLegend = () => {
        legendContainer.innerHTML = ''
        brands.forEach((brand) => {
          const isActive = selectedItems.length === 0 || selectedItems.includes(brand)
          const color = colorMap[brand] || '#ccc'

          const itemDiv = document.createElement('div')
          itemDiv.style.display = 'flex'
          itemDiv.style.alignItems = 'center'
          itemDiv.style.cursor = 'pointer'
          itemDiv.style.userSelect = 'none'
          itemDiv.style.opacity = isActive ? '1' : '0.6'
          itemDiv.style.transition = 'all 0.3s ease'
          itemDiv.style.padding = '4px 0'
          itemDiv.style.marginRight = '10px'

          const marker = document.createElement('span')
          marker.style.display = 'inline-block'
          marker.style.width = '16px'
          marker.style.height = '2px'
          marker.style.marginRight = '8px'
          marker.style.borderRadius = '2px'
          marker.style.backgroundColor = color
          marker.style.transition = 'all 0.3s ease'
          marker.style.flexShrink = '0'
          if (isActive && selectedItems.length > 0) {
            marker.style.boxShadow = `0 0 10px ${color}`
          }

          const text = document.createElement('span')
          text.textContent = brand
          // 根据主题调整颜色
          text.style.color = isActive
            ? (this.dark ? '#00DADA' : '#333')
            : (this.dark ? 'rgba(255,255,255,0.4)' : '#bbb')
          text.style.fontSize = '12px'
          text.style.fontWeight = isActive && selectedItems.length > 0 ? 'bold' : 'normal'
          text.style.transition = 'all 0.3s ease'

          itemDiv.appendChild(marker)
          itemDiv.appendChild(text)

          itemDiv.addEventListener('click', (e) => {
            e.stopPropagation()
            // 点当前唯一选中项 → 取消；否则只选中当前品牌【图例多选模式改为单选模式】
            if (selectedItems.length === 1 && selectedItems[0] === brand) {
              selectedItems.length = 0
            } else {
              selectedItems.length = 0
              selectedItems.push(brand)
            }
            let newData
            if (selectedItems.length === 0) {
              newData = allData
            } else {
              newData = allData.filter(d => selectedItems.includes(d.pinpai))
            }
            renderLegend()
            this.rebuildChart(chartId, chartName, newData)
          })
          legendContainer.appendChild(itemDiv)
        })
      }
      renderLegend()
    },
    rebuildChart(chartId, chartName, chartData) {
      if (this[chartName]) {
        this[chartName].destroy()
        this[chartName] = null
      }
      const h = 130
      this.height = this.realHeight - h
      var sum = 0
      this[chartName] = new Line(chartId, {
        data: chartData,
        height: this.height,
        xField: 'date',
        yField: 'num',
        seriesField: 'pinpai',
        legend: false,
        tooltip: {
          showTitle: true,
          customContent: (title, items) => {
            sum = items.reduce((total, item) => total + item.data.num, 0)
            const newArr = () => {
              const map = new Map()
              for (const item of items) {
                if (!map.has(item.name)) {
                  map.set(item.name, item)
                }
              }
              return [...map.values()]
            }
            const newItems = newArr()
            let itemHtml = ''
            for (const val of newItems) {
              const num = Number(val.value).toFixed(2)
              itemHtml += `<li class="g2-tooltip-list-item">
              <span class="g2-tooltip-marker" style="background:${val.color}"></span>
              <span class="g2-tooltip-name">${val.name}</span>:
              <span class="g2-tooltip-value">${this.dataType.includes('4') || this.dataType.includes('5') ? num : val.value}</span>
            </li>`
            }
            return `<div class="g2-tooltip-title">${title} ${this.filterDataType(this.dataType, sum)}</div>
          <ul class="g2-tooltip-list">` + itemHtml + '</ul>'
          }
        },
        point: {
          shape: () => 'circle',
          size: 3,
          color: (datum) => {
            const colorMap = this.getColorsByNames()
            return colorMap[datum.pinpai] || this.color16()
          }
        },
        lineStyle: ({ pinpai }) => {
          const config = this.currentTypeConfig
          const labelShort = config.labelShort
          if (pinpai.indexOf(labelShort) > -1) {
            return { lineWidth: 3, lineDash: [3, 1] }
          } else if (pinpai.indexOf('站点') > -1) {
            return { lineWidth: 3 }
          } else {
            return { lineWidth: 1 }
          }
        },
        color: (datum) => {
          const colorMap = this.getColorsByNames()
          return colorMap[datum.pinpai] || this.color16()
        }
      })
      this[chartName].on('element:click', (event) => {
        if (event && event.data && event.data.data && event.data.data.num) {
          this.onClickPoint(event.data.data, sum)
        }
      })
      this[chartName].render()
    },
    filterDataType(value, sum) {
      const config = this.typeConfig[Number(value)]
      if (!config) return ''
      // 根据是否为比率决定格式化方式
      const formatted = config.isRate
        ? Number(sum).toFixed(2)
        : Math.round(sum)
      return `${config.label}：${formatted}${config.unit}`
    },
    onClickPoint(data, sum) {
      const vm = this
      if (this.timeType === '日') {
        // 除了月活跃点击查看日期的明细
      } else if (this.timeType === '月' && this.dataType !== '3') {
        if (data.date.slice(-1) === '日') {
          vm.dialogTitleDay =
            new Date().getFullYear() +
            '-' +
            (new Date().getMonth() + 1) +
            '-' +
            data.time +
            (vm.dark ? '曲线图' : '品牌总' + this.filterDataType(this.dataType, sum))
          vm.$refs.daychart.onShowDialog()
          vm.$nextTick(() => {
            vm.tidal(data, 'daychart', 'chartDays')
          })
        }
      } else if (this.timeType === '年') {
        if (data.date.slice(-1) === '月') {
          vm.monthCache = Number(data.time) < 10 ? '0' + data.time : data.time
          if (vm.selectYear) {
            vm.dialogTitleMonth =
              vm.selectYear +
              '-' +
              data.time +
              (vm.dark ? '曲线图' : '品牌总' + this.filterDataType(this.dataType, sum))
          } else {
            vm.dialogTitleMonth =
              new Date().getFullYear() +
              '-' +
              data.time +
              (vm.dark ? '曲线图' : '品牌总' + this.filterDataType(this.dataType, sum))
          }
          vm.$refs.monthchart.onShowDialog()
          vm.$nextTick(() => {
            vm.tidal(data, 'monthchart', 'chartMonths')
          })
        }
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs.monthchart.onCloseDialog()
    },
    handleCloseDay() {
      this.$refs.daychart.onCloseDialog()
    },
    initBrandThrowInData() {
      const params = {
        selfAreaId: this.selfAreaId
      }
      Api.brandPercentNew(params).then((res) => {
        if (res.code === 200) {
          this.brandThrowInData = res.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: inline-block;
}

.btn-group {
  float: right;

  .datatype {
    margin-left: 2px;
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
  }
}
</style>
